export default __webpack_public_path__ + "static/media/map-tile-review.5c6b0e02.svg";